import { LineChartXAxisLabel } from '@modules/charts/components/LineChartWrapper/LineChartXAxisLabel';
import { RecordsNotFoundMessage } from '@modules/common/components/RecordsNotFoundMessage';
import {
  useGetQuantifyAggregatePeriod,
  useIsAnomaliesTrendVisible,
  useQuantifyTimeRangeControls,
} from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Stack } from '@mui/material';
import { QuantifyVisualisationType } from 'generated/graphql';

export const DashboardRecordsNotFound = () => {
  const isTrendVisualisation = useQuantifyStore(
    ({ query }) => query.visualisationType === QuantifyVisualisationType.Trend,
  );
  const aggregatePeriod = useGetQuantifyAggregatePeriod();

  const isAnomaliesTrendVisible = useIsAnomaliesTrendVisible();

  const { secondaryXAxisLabel, isNextDisabled, onPrevClick, onNextClick } =
    useQuantifyTimeRangeControls();

  return (
    <Stack height="100%">
      <RecordsNotFoundMessage
        titleMessage={
          isAnomaliesTrendVisible ? 'No Anomalies Found' : 'No Records Found'
        }
        containerStackProps={{
          height: 'auto',
          flex: 1,
        }}
      />
      {isTrendVisualisation && (
        <LineChartXAxisLabel
          shouldShowTimeRangeControls
          onPrevClick={onPrevClick}
          onNextClick={onNextClick}
          labelData={{
            primary: 'Time-Range',
            secondary: secondaryXAxisLabel,
          }}
          isNextDisabled={isNextDisabled}
          aggregatePeriod={aggregatePeriod}
          containerStackProps={{
            position: 'static',
            pb: 1,
          }}
        />
      )}
    </Stack>
  );
};
